import { createFileRoute } from "@tanstack/react-router";

import { EsporteBauru } from "@/components/itv/pages/EsporteBauru";
import { lerPaginaLocal } from "@/lib/pagina-local";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import bruto from "@/content/locais/medico-do-esporte-em-bauru.md?raw";

const dados = lerPaginaLocal(bruto);

export const Route = createFileRoute("/medico-do-esporte-em-bauru")({
  loader: () => carregarPaginaSimples(dados.url, dados.title, dados.description),
  // O JSON-LD aprovado já traz o médico e o consultório completos.
  staticData: { declaraPhysician: true, declaraClinica: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <EsporteBauru />
      {/* JSON-LD aprovado, sem alteração. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: dados.schema.replace(/</g, "\\u003c") }}
        suppressHydrationWarning
      />
    </>
  );
}
